import { gettext } from '@eventbrite/i18n';
import {
    SelectField,
    SelectFieldProps,
    TextField,
    TextFieldProps,
} from '@eventbrite/marmalade';
import React from 'react';

type RegionFormFieldProps = SelectFieldProps | TextFieldProps;

const isSelect = (
    props: SelectFieldProps | TextFieldProps,
): props is SelectFieldProps => {
    return (props as SelectFieldProps).options?.length > 0;
};

export const RegionFormField = (props: RegionFormFieldProps) => {
    if (isSelect(props)) {
        return <SelectField {...props} />;
    }

    return <TextField {...props} placeholder={gettext('e.g. California')} />;
};
